import React from "react";
import "@/styles/background.css";

export const GlobalBackground: React.FC = () => {
  return (
    <>
      <div className="fixed inset-0 -z-30 bg-[#02060d]" />

      <div
        className="fixed inset-0 -z-20"
        style={{
          background: `
            radial-gradient(
              circle 900px at 50% -8%,
              #b0d9ffff 0%,
              #78bbfaff 2%,
              rgba(255, 255, 255, 0.03) 60%,
              transparent 85%
            ),
            radial-gradient(
              circle 1200px at 50% -20%,
              rgba(112, 186, 255, 0.45) 0%,
              rgba(50, 90, 140, 0.25) 15%,
              rgba(12, 18, 31, 0.85) 40%,
              rgba(0, 0, 0, 0.95) 70%
            )
          `,
        }}
      />

      <div className="fixed inset-0 -z-10 backdrop-blur-[120px]" />

      {/* Star Layers - wrapped in overflow-hidden container to prevent translateX overflow */}
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="star-layer star-layer-1"></div>
        <div className="star-layer star-layer-2"></div>
        <div className="star-layer star-layer-3"></div>
        <div className="star-layer star-layer-4"></div>
        <div className="star-layer star-layer-5"></div>
      </div>
    </>
  );
};
